export default "__VITE_ASSET__ROt9P6j2__"